<template>
<div>
  <Register v-if="editFlag" :parent="$data" />
  <Completion v-else-if="completedFlag" :parent="$data" />
  <Comfirm v-else :parent="$data" />
</div>
</template>

<script>
import Methods from '@/api/methods'
import Comfirm from '../components/RegisterMember/Comfirm'
import Completion from '../components/RegisterMember/Completion'
import Register from '../components/RegisterMember/Register'

export default {
  components : {
    Comfirm,
    Register,
    Completion
  },
  data() {
    return {
      mode         : 'RegisterMember',
      registerData : {
        address : '',
        files   : [],
      },
      constants            : [],
      editFlag             : true,
      completedFlag        : false,
      selectedRegisterType : {},
      filesName            : [],
      confirmEmail         : null,
      confirmPassword      : null,
    }
  },
  methods : {
    getMemberRegisterConstants() {
      this.$store.state.loading = true

      Methods.apiExcute('get-member-regist-constants', this.$i18n.locale).then(data => {
        this.$store.state.loading = false
        this.constants = data
      })
        .catch(error => {
          this.$store.state.loading = false
          this.errors = Methods.parseHtmlResponseError(this.$router, error)
        })
    },
    padArray(array, length) {
      for (let i = 0;i < length;i++) {
        array.push({})
      }
      array.splice(length)
      return array
    }
  },
  created() {
    this.getMemberRegisterConstants()
  },
  watch : {
    '$i18n.locale'() {
      this.getMemberRegisterConstants()
    }
  }
}
</script>
